import type { Technique } from '../types';
import { CONTOUR_LINES_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type ContourLinesState } from './render';

export const contourLines: Technique<ContourLinesState> = {
  id: 'contour-lines',
  name: 'Konturlinien',
  category: 'noise',
  description: 'Bettet den Text in ein Höhenfeld aus Rauschen und zeichnet ihn als Topografie.',
  params: CONTOUR_LINES_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
